/* eslint-disable */
export default {
  participants: 'Teilnehmer',
  host: '(Gastgeber)',
  removeParticipant: 'Teilnehmer entfernen',
  removeTitle: 'Teilnehmer entfernen',
  removeDescription: '{name} aus dieser Konferenz entfernen?',
  confirmButtonText: 'Entfernen',
  cancelButtonText: 'Abbrechen',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
